import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { isTV } from './utils/tvMode';

// Apply data-tv attribute so CSS can disable expensive GPU effects on TV hardware
if (isTV) document.documentElement.setAttribute('data-tv', '');

function showFatal(message: string) {
  const root = document.getElementById('root');
  if (!root) return;
  root.innerHTML = `
    <div style="position:fixed;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:24px;background:#080808;color:#f87171;font-family:Georgia,serif;text-align:center;gap:12px">
      <div style="font-size:14px;letter-spacing:0.3em;text-transform:uppercase;color:#f5b524">CueTitan — startup error</div>
      <pre id="fatal-msg" style="max-width:90vw;white-space:pre-wrap;color:#fca5a5;font-size:12px;font-family:monospace;"></pre>
      <div style="color:#9ca3af;font-size:11px">Reload the app. If it persists, update System WebView from Play Store.</div>
    </div>
  `;
  const pre = root.querySelector('#fatal-msg');
  if (pre) pre.textContent = message;
}

window.addEventListener('error', (ev) => {
  showFatal(String(ev.error?.stack || ev.message || ev));
});
window.addEventListener('unhandledrejection', (ev) => {
  showFatal(String(ev.reason?.stack || ev.reason || 'Unhandled promise rejection'));
});

try {
  const el = document.getElementById('root');
  if (!el) throw new Error('#root element missing');
  ReactDOM.createRoot(el).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (e) {
  showFatal(String((e as Error)?.stack || e));
}
